import { AxiosRequestConfig } from "axios";
import http from "../../http/http";
import Api from "../../http/Api";
import { InheritedAccessDetails } from "../../createTeam/inheritedAccessDetails";

export interface TeamAccessDetailsResponse {
  data: InheritedAccessDetails[];
}

const api = new Api(process.env.API_BASE_URL);

const getTeamAccessDetails = (
  teamId: string
): Promise<TeamAccessDetailsResponse> => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: api.getEndpointUri(`/api/v1/teams/${teamId}/teamAccessDetails`),
  };

  return http
    .request<TeamAccessDetailsResponse>(config)
    .then((res) => res.data);
};

export default getTeamAccessDetails;
